$('.btn-service').click(function (event) {
    event.preventDefault();
    $("#" + $(this).data("for")).val($(this).data("id"));
    checkServiceSelected($(this).data("for"));
});

function checkServiceSelected(element) {
    const selectedValue = $("#" + element).val();
    if (selectedValue) {
        $(".btn-service").each(function () {
            if ($(this).data("for") === element) {
                if ($(this).data("id") == selectedValue) {
                    $(this).addClass("selected");
                } else {
                    $(this).removeClass("selected");
                }
            }
        });
    }

    if($("#c_deliveryoption").val() && $("#c_paymentoption").val()){
        $("#btn-checkout-submit").show();
    } else {
        $("#btn-checkout-submit").hide();
    }
}

$(".edit-editor-modal-button").on('click', function () {
    $("#editor-modal-continue-button").attr("href", $(this).data("href"));
})

$(".delete-editor-modal-button").on('click', function () {
    $("#editor-modal-continue-button").attr("href", $(this).data("href"));
})

$(document).ready(function () {

    $(window).keydown(function (event) {
        if ((event.keyCode == 13)) {
            event.preventDefault();
            return false;
        }
    });

    if ($('#checkout-current-step').data("page") === "delivery") {
        checkServiceSelected("c_deliveryoption");
        checkServiceSelected("c_paymentoption");
    }
    if ($('#checkout-current-step').data("page") === "process") {
        let form = $('#checkout-form');
        form.on('submit', function (e) {
            $.LoadingOverlay("show", {});
        });
    }

    var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');

    function checkModal(modalId) {
        if ($("#" + modalId).length) {
            return $("#" + modalId);
        } else {
            return $(document.body);
        }
    }

    $("#address-billing-state_id").select2({
        theme: "bootstrap4",
        minimumResultsForSearch: 10,
        dataAdapter: customAdapter,
        sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
        dropdownParent: checkModal("billing-address-modal"),
        placeholder: function () {
            $(this).data('placeholder');
        },
    });

    $('[id^="address-delivery-state_id_"]').each(function (index) {
        $(this).select2({
            theme: "bootstrap4",
            minimumResultsForSearch: 10,
            dataAdapter: customAdapter,
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
            dropdownParent: checkModal("shipping-address_modal_" + index),
            placeholder: function () {
                $(this).data('placeholder');
            },
        });
    });

    if ($("#cart-type").length) {
        let url = new URL(window.location.href);
        if (!url.searchParams.get("cart_type")) {
            url.searchParams.set('cart_type', $("#cart-type").data("type"));
        }

        let state = history.state;
        let title = document.title;
        history.pushState(state, title, url);
    }
});


$(window).on('load', function () {
    //Redirect gateway pagamento
    var form = $(".checkout-standard form").first();
    var node = $(".checkout-standard-process", form);
    var anchor = $("a.btn-action", node);
    var errors = $("#error-container .alert");

    if(errors.length === 0) {
        if (anchor.length > 0) {
            window.location = anchor.attr("href");
        } else if (node.length > 0 && node.has(".mandatory").length === 0 && node.has(".optional").length === 0 && form.attr("action") !== '') {
            form.submit();
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const elemJS = document.getElementById("process-payment.cardno");
    if (elemJS) {
        const elem = $(elemJS);
        elem.attr("type", "tel");
        const elemIcon = $("<div class='checkout-credit-card-field-icon'><i class='fa-regular fa-xl fa-credit-card'></i></div>")
        elem.parent().append(elemIcon);

        let cleave = new Cleave(elemJS, {
            creditCard: true,
            creditCardStrictMode: true,
            onCreditCardTypeChanged: function (type) {
                switch (type) {
                    case "mastercard":
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-brands fa-xl fa-cc-mastercard');
                        break;
                    case "visa":
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-brands fa-xl fa-cc-visa');
                        break;
                    case "amex":
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-brands fa-xl fa-cc-amex');
                        break;
                    case "diners":
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-brands fa-xl fa-cc-diners-club');
                        break;
                    case "jcb":
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-brands fa-xl fa-cc-jcb');
                        break;
                    case "discover":
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-brands fa-xl fa-cc-discover');
                        break;
                    default:
                        elemIcon.children('i').removeClass();
                        elemIcon.children('i').addClass('fa-regular fa-xl fa-credit-card');
                }
            }
        });
    }
});

$('#checkout-guest').click(function (event) {
    event.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/set_checkout_as_guest',
    })
    $("#checkout-auth").hide();
    $("#checkout-funnel").show();
});

$('.btn-checkout-submit, #payment-button').click(function (event) {
    let form = $('#checkout-form');
    let step = $('#checkout-current-step').data("page");
    //Se sono in versione modale NON devo lanciare la validazione JS perchè gli eventuali elementi invalidi non sono mostrabili
    if (step === "address" && !$('#billing-address-modal').length) {
        if (form[0]) {
            if (form[0].checkValidity()) {
                form.on('submit', function (e) {
                    $.LoadingOverlay("show", {});
                });
            } else {
                event.preventDefault();
                form[0].reportValidity();
            }
        }
    } else if (step === "summary" || step === "process") {
        $("#message-req-terms").hide();
        if (form[0]) {
            if (!form[0].checkValidity()) {

                let isValid = true;
                if (!$("input[name='cs_option_terms_value']").is(":checked")) {
                    isValid = false;
                }
                if (!$("input[name='cs_option_additional_terms']").is(":checked")) {
                    isValid = false;
                }
                if (!$("input[name='cs_option_privacy']").is(":checked")) {
                    isValid = false;
                }

                if (!isValid) {
                    $("#message-req-terms").show();
                }

                event.preventDefault();
                form[0].reportValidity();
            }
        }
    }

    form.on('submit', function (e) {
        $.LoadingOverlay("show", {});
    });
});

$(".promo-apply").click(function (event) {
    if ($('#b_coupon').val() != "") {
        $.LoadingOverlay("show", {});
    }
})

$(".checkout-button a, .promo-delete").click(function (event) {
    $.LoadingOverlay("show", {});
})

$('.btn-print-basket-submit').click(function (e) {
    var that = $(this);
    $("#form-basket-quote-print").submit();
});
